export default "__VITE_ASSET__DgmLH5$h__"